// @mui
import Box from '@mui/material/Box';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
//
import { useAuthContext } from 'src/auth/hooks';
import { Colors } from 'src/theme/palette';
import { usePathname } from 'src/routes/hooks';
import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { usePrevious } from 'src/hooks/use-previous';
import Main from './main';
import Header from './header';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';


// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function DashboardLayout({ children }: Props) {
  const settings = useSettingsContext();
  const context = useAuthContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean(lgUp);
  const pathname = usePathname();

  const lgUpPrev = usePrevious(lgUp);
  useEffect(() => {
    if (lgUp) {
      const stored = localStorage.getItem('ct-navbar-open');
      if (stored !== null) {
        nav.setValue(stored === 'true');
        return;
      }
    } else if (lgUpPrev === undefined || lgUpPrev) {
      nav.onFalse();
      return;
    }
    if (lgUp && lgUpPrev !== undefined && !lgUpPrev) {
      nav.onFalse();
    }
  }, [lgUp, lgUpPrev, nav]);

  useEffect(() => {
    (window as any).enqueueSnackbar = enqueueSnackbar;

    return () => { delete (window as any).enqueueSnackbar; };
  }, []);

  if (!context?.session) {
    return undefined;
  }

  const isHorizontal = settings.themeLayout === 'horizontal';

  const iftaOnly = !!context?.session?.organization?.iftaOnly;

  const customLogoUrl = context?.session?.organization?.companyLogoUrl;
  if (isHorizontal) {

    return (
      <>
        <Header openNav={nav.value} onOpenNav={() => {
          const newState = !nav.value;
          localStorage.setItem('ct-navbar-open', newState ? 'true' : 'false');
          nav.onToggle();
        }} iftaOnly />

        {!iftaOnly && <>
          {lgUp ? <NavHorizontal /> : <NavVertical openNav={nav.value} customLogoUrl={customLogoUrl} onCloseNav={() => {
            localStorage.setItem('ct-navbar-open', 'false');
            nav.onFalse();
          }}/>}
        </>}
        <Main openNav={nav.value}>{children}</Main>
      </>
    );
  }

  return (
    <>
      <Box displayPrint="none">
        <Header openNav={nav.value} onOpenNav={() => {
          const newState = !nav.value;
          localStorage.setItem('ct-navbar-open', newState ? 'true' : 'false');
          nav.onToggle();
        }}/>
      </Box>

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          // UF
          flexDirection: { xs: pathname.includes("app/devices/map") || pathname.includes("app/eld/dashboard") ? 'row' : 'column', md: 'row' },
        }}
      >

        <Box displayPrint="none" sx={{background: Colors.topbarSidebar, zIndex: 1, boxShadow: "-1px -3px 6px #ddd"}}>
          <NavVertical openNav={nav.value} customLogoUrl={customLogoUrl} onCloseNav={() => {
            localStorage.setItem('ct-navbar-open', 'false');
            nav.onFalse();
          }}/>
        </Box>

        <Main openNav={nav.value}>{children}</Main>
      </Box>
    </>
  );
}
